import type { TrackingFeature } from '@shared/types/tracking.ts';
import type { BlackFridaySliderItem } from '@tilelist/domain/composition/TileListitem.ts';

export const BLACK_FRIDAY_SLIDER_FEATURE_ID = 'find_slider_1';
const SLIDER_TYPE = 'rating_black_friday';
const TILELIST_FEATURE_ID = 'find_tilelist_1';

export function sliderTileFeatureId(position: number): string {
    return `find_slider_tile_${position}`;
}

export function blackFridaySliderLabels() {
    return { san_ListSliderType: [SLIDER_TYPE] };
}

/**
 *
 *
 */
export function blackFridaySliderFeatures(slider: BlackFridaySliderItem): TrackingFeature[] {
    if (slider.state !== 'ready') return [];

    return [
        {
            id: BLACK_FRIDAY_SLIDER_FEATURE_ID,
            name: 'slider',
            status: 'loaded',
            parentId: TILELIST_FEATURE_ID,
            labels: { san_SliderType: [SLIDER_TYPE], san_SliderFilledSlots: [String(slider.items.length)] },
        },
        ...slider.items.map((item): TrackingFeature => ({
            id: sliderTileFeatureId(item.localListPosition),
            name: 'tile',
            position: item.localListPosition,
            variationId: item.product.bestVariationId,
            status: 'loaded',
            parentId: BLACK_FRIDAY_SLIDER_FEATURE_ID,
            labels: { san_ProductType: [item.product.productType] },
        })),
    ];
}
